import styled from 'styled-components';

export const SchAutoListDesktop = styled.div`
  width: 541px;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.03);

  .area-list {
    padding: 24px;
  }

  .auto-keyword,
  .auto-brand {
    .item {
      margin-top: 12px;
      height: 19px;

      &:first-child {
        margin-top: 0;
      }

      .btn {
        height: auto;
      }

      .name {
        font-size: 15px;
        color: #555;
      }

      .name-en {
        font-size: 13px;
        margin-left: 6px;
        color: #acacac;
      }

      .tag {
        font-size: 11px;
        font-weight: 500;
      }
    }
  }

  .auto-brand {
    .btn {
      padding-right: 18px;
    }
  }

  .auto-brand + .auto-keyword {
    border-top: 1px solid #f5f5f5;
    padding-top: 18px;
    margin-top: 18px;
  }

  .bottom {
    width: 100%;
    border-top: 1px solid #eee;
    text-align: right;
    padding-right: 20px;

    .btn {
      height: 40px;
      font-size: 13px;
      line-height: 130%;
      color: #999;
    }
  }
`;
